import UserRecommendedVideosContainer from './UserRecommendedVideosContainer';
export default UserRecommendedVideosContainer;
